import { environment } from './../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Dialog } from '@core/models/dialog.interface';
import { ConfirmDialogComponent } from '@shared/components/modal/confirm-dialog/confirm-dialog.component';
import { Subject, Observable } from 'rxjs';
import { ModalService } from './modal.service';
import { Router } from '@angular/router';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  //loading = new Observable<boolean>;
  
  private loading = new Subject<boolean>();
  public loadingStatic = false;
  
  private loadingIndep = new Subject<boolean>();
  public loadingStaticIndep = false;

  getLoading(): Observable<boolean> {
    return this.loading.asObservable();
  }
  getLoadingIndep(): Observable<boolean> {
    return this.loadingIndep.asObservable();
  }

  public momentoInicial: any = null;
  public momentoFinal: any = null; 

  // Observable para cancelar todas las peticiones pendientes
  private ngUnsubscribe = new Subject<void>();
  getNgUnsubscribe(): Observable<void> {
    return this.ngUnsubscribe.asObservable();
  }

  cancelAllHttpRequest() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.ngUnsubscribe = new Subject<void>(); 
  }

  private isCancelHttpRequest = new Subject<boolean>();
  public isCancelHttpRequestStatic = false;

  getIsCancelHttpRequest(): Observable<boolean> {
    return this.isCancelHttpRequest.asObservable();
  }

  setIsCancelHttpRequest(show: boolean) {
    this.isCancelHttpRequest.next(show);
    this.isCancelHttpRequestStatic = show;
  }  
  
  constructor(
    private http: HttpClient, 
    private _modalService: ModalService,
    private router: Router
  ) {
  }
    
  postMotor(data: any, code: string) {
    let headers = new HttpHeaders();
    //headers = headers.set('IdToken-Cognito', localStorage.getItem('tokenInitial')!).set('RefeshToken-Cognito',localStorage.getItem('tokenRefresh')!).set('TokenMotor',localStorage.getItem('token_motor')!);
    let datos = {
      op: 1,
      datos_front: {
        ...data,
      },
      motor_codigo: code,
      credito_id: 1,
      empresa_id: 2,
    };
    return this.http.post(localStorage.getItem('urlMotor') + '/ejecucionmotor/ejecutar', datos);
  }
  
  postMotorPromise(data: any, code: string, alert = true, motorStructure = true, url = '') {
    return new Promise<any>((resolve, reject) => {
      let headers = new HttpHeaders();
      //headers = headers.set('IdToken-Cognito', localStorage.getItem('tokenInitial')!).set('RefeshToken-Cognito',localStorage.getItem('tokenRefresh')!).set('TokenMotor',localStorage.getItem('token_motor')!);
      let datos: any;
      
      if(motorStructure) {
        datos = {
          op: 1,
          datos_front: {
            ...data,
          },
          motor_codigo: code,
          //credito_id: 1,
          //empresa_id: 2,
        };
      } else {
        datos = data
      }

      return this.http.post<any>(motorStructure ? localStorage.getItem('urlMotor') + '/ejecucionmotor/ejecutar' : localStorage.getItem('urlMotor') + url, datos).subscribe((response: any) => {
        if (response) {
          //console.log(response);
          
          if (response.error == 0) {
            // localStorage.setItem('Id-Token-Cognito', response.datos.resp_motor.IdToken)
            if(motorStructure){
              resolve(response.datos.resp_motor)
            }else{
              resolve(response)
            }
          } else {
            reject(response)
            if (alert && document.querySelectorAll('nz-modal-container').length == 0) {
              this.setLoading(false)
              this.showMessage(
                response.mensaje ? response.mensaje : 'No se pudo ejecutar la petición.',
                'fal fa-exclamation'
              );
            }
          }
        } else {
          reject(response)
          if (alert && document.querySelectorAll('nz-modal-container').length == 0) {
            this.setLoading(false)
            this.showMessage(
              response.mensaje ? response.mensaje : 'No se pudo ejecutar la petición.',
              'fal fa-exclamation'
            );
          }
        }
      }, (error:any)=>{
        console.log(error);
        let errorBoolean = false;
        try {
          errorBoolean = !!error.error.datos.resp_motor.datos[0];
        } catch (error) {
          errorBoolean = false;
        }
        console.log(errorBoolean);
        
        if (error.status == 404) {
          resolve({ datos: [[]], error: true });
        } else if (error.status == 401) {
          this.setLoading(false)
          reject(error)
          this.showMessage(
            errorBoolean ? error.error.datos.resp_motor.datos[0] : 'Su sesión ha expirado.',
            'fal fa-exclamation',
            ()=> {
              this.router.navigate(['/login']);
            }
          );
        } else if (error.status == 400) {
          this.setLoading(false)
          reject(error)
          if (alert && document.querySelectorAll('nz-modal-container').length == 0) {
            this.showMessage(
              errorBoolean ? error.error.datos.resp_motor.datos[0] : 'Ocurrió un problema en la petición.',
              'fal fa-exclamation'
            );
          }
        } else if (error.status == 403) {
          this.setLoading(false)
          reject(error)
          if (alert && document.querySelectorAll('nz-modal-container').length == 0) {
            this.showMessage(
              errorBoolean ? error.error.datos.resp_motor.datos[0] : 'No tiene permisos para realizar esta acción.',
              'fal fa-exclamation',
            );
          }
        } else if (error.status == 500) {
          this.setLoading(false)
          reject(error)
          if (alert && document.querySelectorAll('nz-modal-container').length == 0) {
            this.showMessage(
              errorBoolean ? error.error.datos.resp_motor.datos[0] : 'Error interno del servidor.',
              'fal fa-exclamation',
            );
          }
        } else {
          this.setLoading(false)
          reject(error)
          if(alert && document.querySelectorAll('nz-modal-container').length == 0){
            this.setLoading(false)
            this.showMessage(
              errorBoolean ? error.error.datos.resp_motor.datos[0] : 'Ha ocurrido un error en la consulta',
              'fal fa-exclamation'
            );
          }
        }
      });
    });
  }
  
  post(data: any, url = '', alert = true) {
    return new Promise<any>((resolve, reject) => {
      let headers = new HttpHeaders();
      //headers = headers.set('IdToken-Cognito', localStorage.getItem('tokenInitial')!).set('RefeshToken-Cognito',localStorage.getItem('tokenRefresh')!).set('TokenMotor',localStorage.getItem('token_motor')!);

      return this.http.post(url, data).subscribe((response: any) => {
        
        if (response) {
          if (response.error == 0) {
            // localStorage.setItem('Id-Token-Cognito', response.datos.resp_motor.IdToken)
            resolve(response)
          } else {
            reject(response)
            if (alert && document.querySelectorAll('nz-modal-container').length == 0) {
              this.setLoading(false)
              this.showMessage(
                'Ha ocurrido un error en la consulta',
                'fal fa-exclamation'
              );
            }
          }
        } else {
          reject(response)
          if (alert && document.querySelectorAll('nz-modal-container').length == 0) {
            this.setLoading(false)
            this.showMessage(
              'Ha ocurrido un error en la consulta',
              'fal fa-exclamation'
            );
          }
        }
      }, (error:any)=>{
        if (error.status == 404) {
          resolve({ datos: [[]], error: true });
        } else if (error.status == 401) {
          this.setLoading(false)
          reject(error)
          this.showMessage(
            'Su sesión ha expirado.',
            'fal fa-exclamation',
            ()=> {
              this.router.navigate(['/login']);
            }
          );
        } else if (error.status == 400) {
          this.setLoading(false)
          reject(error)
          if (document.querySelectorAll('nz-modal-container').length == 0) {
            this.showMessage(
              'Ocurrió un problema en la petición.',
              'fal fa-exclamation'
            );
          }
        } else if (error.status == 403) {
          this.setLoading(false)
          reject(error)
          if (document.querySelectorAll('nz-modal-container').length == 0) {
            this.showMessage(
              'No tiene permisos para realizar esta acción.',
              'fal fa-exclamation',
            );
          }
        } else if (error.status == 500) {
          this.setLoading(false)
          reject(error)
          if (document.querySelectorAll('nz-modal-container').length == 0) {
            this.showMessage(
              'Error interno del servidor.',
              'fal fa-exclamation',
            );
          }
        } else {
          this.setLoading(false)
          reject(error)
          if(alert && document.querySelectorAll('nz-modal-container').length == 0){
            this.setLoading(false)
            this.showMessage(
              'Ha ocurrido un error en la consulta',
              'fal fa-exclamation'
            );
          }
        }
      });
    });
  }

  postDirect(url: string, data: any, params: string | any = null, alert: boolean = true): Promise<any> {
    if (this.momentoInicial == null) {
      this.momentoInicial = JSON.parse(localStorage.getItem('momentoInicial')!);
    }
    return new Promise((resolve, reject) => {
      const rutas: any = environment;
      localStorage.setItem('momentoInicial', JSON.stringify(new Date()));
      this.momentoInicial = new Date();
      this.http.post<any>((params ? `${rutas[url]}${params}` : rutas[url]), data, { observe: 'response', headers: { direct: 'true' } } ).pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response: any) => {
          localStorage.setItem('momentoInicial', JSON.stringify(new Date()));
          this.momentoInicial = new Date();
          resolve(response);
          },
          (error: any) => {

            if (error.status == 404) {
              resolve({ datos: { informacion_general: []}, error: true });
            } else if(error.status == 404){
              reject(error)
  
              if (alert && document.querySelectorAll('nz-modal-container').length == 0) {
                this._modalService.closeAllModals();
                this.cancelAllHttpRequest();
                setTimeout(() => {
                  this.setLoading(false);
                  this.setLoadingIndep(false);
                  this.showMessage(
                    error.error.data ? error.error.data : 'No se han encontrado resultados.',
                    'fal fa-exclamation'
                  );
                }, 300);
              }
            } else if (error.status == 401 ) {
              this.setLoading(false);
              this.setLoadingIndep(false);
              reject(error);
              this._modalService.closeAllModals();
              this.showMessage(
                error.error.data ? error.error.data : 'Su sesión ha expirado.',
                'fal fa-exclamation',
                ()=> {
                  this.router.navigate(['/login']);
                }
              );  
            } else if (error.status == 400 ) {
              if(alert && document.querySelectorAll('nz-modal-container').length == 0){
                this.setLoading(false);
                this.setLoadingIndep(false);
                this._modalService.closeAllModals();
                this.cancelAllHttpRequest();
                setTimeout(() => {
                  this.showMessage(
                    error.error.data ? error.error.data: 'Ocurrió un problema en la petición.',
                    'fal fa-exclamation'
                  );
                }, 300);
              }
              reject(error)
            } else if (error.status == 403) {
              this.setLoading(false);
              this.setLoadingIndep(false);
              reject(error)
              this.cancelAllHttpRequest();
              setTimeout(() => {
                this.showMessage(
                  error.error.data ? error.error.data : 'No tiene permisos para realizar esta acción.',
                  'fal fa-exclamation',
                );
              }, 300);
            } else if (error.status == 500) {
              this.setLoading(false);
              this.setLoadingIndep(false);
              reject(error)
              this._modalService.closeAllModals();
              this.cancelAllHttpRequest();
              if(alert && document.querySelectorAll('nz-modal-container').length == 0){
                setTimeout(() => {
                  this.showMessage(
                    error.error.data ? error.error.data : 'Error interno del servidor.',
                    'fal fa-exclamation',
                  );
                }, 300);
              }
    
            } else {
              this.setLoading(false);
              this.setLoadingIndep(false);
              reject(error)
              this._modalService.closeAllModals();
              if(alert){
                //console.log('hola mundo')
                this.cancelAllHttpRequest();
                setTimeout(() => {
                  this.setLoading(false);
                  this.setLoadingIndep(false);
                  if(document.querySelectorAll('nz-modal-container').length == 0){
                    this.showMessage(
                      error.error ? error.error : 'Ha ocurrido un error en la consulta',
                      'fal fa-exclamation'
                    );  
                  }
                }, 300); 
              }
            }
  
          }
        )
    });
  }

  getDirect(url: string, params: any = null, alert: boolean = true, validate404:boolean = false): Promise<any> {
    /* this.show(); */

    if (this.momentoInicial == null) {
      this.momentoInicial = JSON.parse(localStorage.getItem('momentoInicial')!);
    }    
    const rutas: any = environment;
    return new Promise((resolve, reject) => {
      localStorage.setItem('momentoInicial', JSON.stringify(new Date()));
      this.momentoInicial = new Date();
      
      this.http.get<any>((params ? `${rutas[url]}${params}` : rutas[url]), { headers: { direct: 'true' }}).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (response: any) => {
          localStorage.setItem('momentoInicial', JSON.stringify(new Date()));
          this.momentoInicial = new Date();          
          resolve(response);
        },
        (error: any) => {

          if (error.status == 404 && !validate404) {
            resolve({ datos: { informacion_general: []}, error: true });
          } else if(error.status == 404 && !validate404){
            reject(error)

            if (alert && document.querySelectorAll('nz-modal-container').length == 0) {
              this._modalService.closeAllModals();
              //this.cancelAllHttpRequest();
              this.setIsCancelHttpRequest(true);
              this.setLoading(false);
              this.setIsCancelHttpRequest(true);                
              this.setLoadingIndep(false);
              this.setIsCancelHttpRequest(true);
              this.showMessage(
                error.error.data ? error.error.data : 'No se han encontrado resultados.',
                'fal fa-exclamation'
              );
            }
          } else if (error.status == 401 ) {
            this.setLoading(false);
            this.setLoadingIndep(false);
            reject(error);
            this._modalService.closeAllModals();
            this.showMessage(
              error.error.data ? error.error.data : 'Su sesión ha expirado.',
              'fal fa-exclamation',
              ()=> {
                this.router.navigate(['/login']);
              }
            );  
          } else if (error.status == 400 ) {
            if(alert && document.querySelectorAll('nz-modal-container').length == 0){
              this.setLoading(false);
              this.setLoadingIndep(false);
              this._modalService.closeAllModals();
              //this.cancelAllHttpRequest();
              this.setIsCancelHttpRequest(true);
              this.showMessage(
                error.error.data ? error.error.data: 'Ocurrió un problema en la petición.',
                'fal fa-exclamation'
              );
            }
            reject(error)
          } else if (error.status == 403) {
            this.setLoading(false);
            this.setLoadingIndep(false);
            reject(error)
            if(alert && document.querySelectorAll('nz-modal-container').length == 0){
              this.showMessage(
                error.error.data ? error.error.data : 'No tiene permisos para realizar esta acción.',
                'fal fa-exclamation',
              );
            }
          
          } else if (error.status == 500) {
            this.setLoading(false);
            this.setLoadingIndep(false);
            reject(error)
            //this.cancelAllHttpRequest();
            this.setIsCancelHttpRequest(true);            
            if(alert && document.querySelectorAll('nz-modal-container').length == 0){
                this.showMessage(
                  error.error.data ? error.error.data : 'Error interno del servidor.',
                  'fal fa-exclamation',
                );
            }
  
          } else {
            reject(error)
            this._modalService.closeAllModals();
            if(alert){
              this.setIsCancelHttpRequest(true);
              this.setLoading(false);
              this.setLoadingIndep(false);
              if(document.querySelectorAll('nz-modal-container').length == 0){
                this.showMessage(
                  error.error.data ? error.error.data : 'Ha ocurrido un error en la consulta',
                  'fal fa-exclamation'
                );  
              }
            }
          }

        }
      );
    });
  }  
  
  showMessage(message: any, icono: any, callback = ()=>{}) {
    let data: Dialog = {
      icon: icono,
      text: message,
      confirmButton: { text: 'Entendido', icon: 'fal fa-check' },
      type: 'message',
      header: { isCloseIcon: true },
    };

    const modal = this._modalService.openModal(
      ConfirmDialogComponent,
      'nzXs',
      { padding: '52px 24px 0 24px' },
      data,
      false
    );

    modal.afterClose.subscribe(()=> {
      callback();
    })
  }

  setLoading(show: boolean) {
    this.loading.next(show);
    this.loadingStatic = show;
  }

  setLoadingIndep(show: boolean) {
      this.loadingIndep.next(show);
      this.loadingStaticIndep = show;
    }

  formTouched(form: any) {
    form.markAllAsTouched();
    for (const key in form.controls) {
      form.get(key).markAsDirty();
    }
  }


  toBase64(url: any) {
    return new Promise<any>((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = () => {
        var reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    })
  }
  
  arrayBufferToBase64(buffer:any) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  getFullName(firstName:string, middleName:string, firstLastname:string, secondLastName:string){
    return this.validateString(firstName) + ' ' 
    + this.validateString(middleName) + ' ' 
    + this.validateString(firstLastname) + ' ' 
    + this.validateString(secondLastName);
  }

  validateString(data:any){
    return data ? data : '';
  }  

  markArrayDirty(formArray: FormArray) {
    formArray.controls.forEach(control => {
      switch (control.constructor.name) {
        case "FormGroup":
          this.markGroupDirty(control as FormGroup);
          break;
        case "FormArray":
          this.markArrayDirty(control as FormArray);
          break;
        case "FormControl":
          this.markControlDirty(control as FormControl);
          break;
      }
    });
  }

  markControlDirty(formControl: FormControl) {
    formControl.markAsDirty();
  }

  markDirty(form: FormGroup) {
    this.markGroupDirty(form);
  }

  markGroupDirty(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      switch (formGroup.get(key)?.constructor.name) {
        case "FormGroup":
          this.markGroupDirty(formGroup.get(key) as FormGroup);
          break;
        case "FormArray":
          formGroup.get(key)?.markAsDirty();
          this.markArrayDirty(formGroup.get(key) as FormArray);
          break;
        case "FormControl":
          this.markControlDirty(formGroup.get(key) as FormControl);
          break;
      }
    });
  }

  logOut() {

    let dataModal:Dialog = {
      icon: "fal fa-info-circle",
      text: "¿Está seguro que desea salir?",
      confirmButton: {text:"Aceptar", icon: "fal fa-check"},
      cancelButton: {text:"Cancelar", icon: "fal fa-chevron-left"},
      type: "confirm"
    }
  
    const modal = this._modalService.openModal(
      ConfirmDialogComponent,
      'nzXs',
      {padding: '3.25rem 1.5rem 0 1.5rem'},
      dataModal
    );
    modal.afterClose.subscribe(async (result)=>{
      if(result){
        this.router.navigate(['/login']);
        localStorage.clear();
      }
    })

  }  

}
